import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
const app = createApp(App);

// 定义全局方法
app.config.globalProperties.$isMobile = function() {
  return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) !== null;
};

// 动态加载 config.js
fetch('/config.js')
  .then(response => response.text())
  .then(scriptText => {
    eval(scriptText); // 执行 config.js 中的代码
    app.config.globalProperties.$config = window.config; // 假设 config.js 中定义了 window.config
    app.use(router);
    app.use(ElementPlus);
    app.mount('#app');
  });
